import { InfoCircle } from "react-bootstrap-icons";
import { HashLink as Link } from "react-router-hash-link";
import styles from "./PlaceholderTutorialLink.module.scss";

/**
 * Reusable component for the placeholder tutorial link that appears throughout the application.
 * Displays an info icon and a link to the customizing section of the tutorials page.
 */
export default function PlaceholderTutorialLink() {
  return (
    <p className={styles.placeholderLink}>
      <InfoCircle className="mr-2" style={{ marginRight: 10 }} />
      <Link to="/tutorials#customizing" target="_blank">
        Learn how to customize your content with Placeholders.
      </Link>
    </p>
  );
}
